var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4452 7.42912L12.5512 11.5001L16.4452 15.5711L14.8942 17.1926L11.0002 13.1331L7.11718 17.1926L5.55518 15.5596L9.43818 11.5001L5.55518 7.44062L7.11718 5.80762L11.0002 9.86712L14.8942 5.80762L16.4452 7.42912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveWhite);
export default __webpack_public_path__ + "static/media/inactive-white.c714dd007a698c0aaba03b27bb67fdaf.svg";
export { ForwardRef as ReactComponent };